module.exports = __webpack_public_path__ + "img/recovery-card-fmk-banner.58f4bb38.png";